import React from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { Box, Typography, LoadingIndicator } from '@drivekyte/ui';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import styled from 'styled-components';
import useTranslation from '@/hooks/use-translation';
import usePDFStepper from '../../hooks/use-pdf-stepper';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

type PDFViewerProps = {
  title: string;
  pdfUrl: string;
};

const PDFViewer = ({ title, pdfUrl }: PDFViewerProps) => {
  const { t } = useTranslation('pages.docs.pdf-viewer');

  const {
    currentPage,
    totalPages,
    isLoading,
    goForward,
    goPrevious,
    setTotalPages,
  } = usePDFStepper();

  return (
    <Box
      display="flex"
      alignItems="center"
      flexDirection="column"
      paddingBottom="xLarge"
    >
      <Box marginBottom="$small">
        <Typography color="primary" variant="headingLarge">
          {title}
        </Typography>
      </Box>

      <TermsContainer width={isLoading ? '100%' : 'auto'}>
        <Box
          backgroundColor="white"
          paddingVertical="$small"
          paddingHorizontal="$none"
          maxWidth="100%"
        >
          <Document
            file={pdfUrl}
            loading={<LoadingIndicator />}
            onLoadSuccess={(data) => setTotalPages(data.numPages)}
            externalLinkTarget="_blank"
          >
            <Page
              pageNumber={currentPage}
              loading={<LoadingIndicator />}
              renderAnnotationLayer
            />
          </Document>
        </Box>
      </TermsContainer>

      <Box
        style={{ userSelect: 'none' }}
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
        position="relative"
        top="-40px"
        zIndex={2}
      >
        <Box cursor="pointer" onPress={goPrevious} marginRight="$tiny">
          <Typography color="primary" variant="labelMedium">
            ←
          </Typography>
        </Box>
        <Box paddingHorizontal="base">
          {t('stepper', { currentPage, totalPages })}
        </Box>
        <Box cursor="pointer" onPress={goForward} marginLeft="$tiny">
          <Typography color="primary" variant="labelMedium">
            →
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

const TermsContainer = styled(Box)`
  padding: 30px 0;
  max-width: 100%;
  box-shadow: 0 0 1px 0 rgba(100, 109, 130, 0.1),
    0 4px 10px 0 rgba(100, 109, 130, 0.14);
  text-align: center;

  .annotationLayer {
    display: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  canvas {
    max-width: 100%;
    height: unset !important;
  }
`;

export default PDFViewer;
